import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { subscribe } from 'alfa';
import { Icon, Typography } from 'antd';
import { withTranslation } from 'react-i18next';

import AccountList from './components/list';
import AccountRepo from '../../repository/account';
import Link from '../../components/link';
import { getUpdatedOrPrependedList } from '../../helpers/list';

const { Title } = Typography;

const AccountIndex = ({ location, business, t }) => {
  const [loading, setLoading] = useState(true);
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    const { state: historyState = {} } = location || {};
    const fetchData = async () => {
      try {
        const { data: { accounts: dataAccounts } } = await AccountRepo.fetchCollection(business);
        if (historyState.newAccount) {
          const updatedAccounts = getUpdatedOrPrependedList(dataAccounts, historyState.newAccount);
          setAccounts(updatedAccounts);
        } else {
          setAccounts(dataAccounts);
        }
      } catch (error) {
        console.error('ERROR: AccountIndex AccountRepo.fetchCollection(): ', error); // eslint-disable-line no-console
      }
    };
    fetchData();
    setLoading(false);
  }, [business, location]);

  return (
    <>
      <Title level={3}>
        {t('accounts')}
        <span style={{ float: 'right' }}>
          <Link button to="/accounts/new"><Icon type="plus" /> {t('create_account')}</Link>
        </span>
      </Title>

      <AccountList loading={loading} accounts={accounts} full />
    </>
  );
};

AccountIndex.propTypes = {
  business: PropTypes.object,
  location: PropTypes.object,
  t: PropTypes.func,
};

export default subscribe(withTranslation()(AccountIndex), ['business']);
